export default __webpack_public_path__ + "images/cce8237351166d8dfc5237d49a4dbf70.svg";